import React from "react";
import PropTypes from "prop-types";

import { DynamicField } from "scenes/Hubly/components/Workspace/components/FormModal/components";

import { useFormFieldController } from "../../hooks";
import { Dropdown } from "..";

export function FormFieldCondition({
  disabled,
  id,
  operand,
  parameters,
  datePart,
  value,
  formField,
}) {
  const {
    formFieldProps,
    datePartProps,
    operandProps,
    fieldProps,
    hasDatePart,
    hasOperand,
    hasField,
  } = useFormFieldController({
    name: id,
    formField: formField,
    operand: operand,
    datePart: datePart,
    value: value,
    parameters: parameters,
  });

  return (
    <div data-test="form-field-condition" style={{ display: "flex" }}>
      <div style={{ width: 200 }}>
        <Dropdown
          disableClearable
          includeInputInList
          data-test="form-field-name-dropdown"
          disabled={disabled}
          {...formFieldProps}
        />
      </div>
      {hasDatePart && (
        <div style={{ width: 120, margin: "0px 16px" }}>
          <Dropdown
            disableClearable
            includeInputInList
            data-test="form-field-datepart-dropdown"
            disabled={disabled}
            {...datePartProps}
          />
        </div>
      )}
      {hasOperand && (
        <div
          style={
            hasDatePart
              ? { width: 135, marginRight: "16px" }
              : { width: 135, margin: "0px 16px" }
          }
        >
          <Dropdown
            disableClearable
            includeInputInList
            data-test="form-field-operand-dropdown"
            disabled={disabled}
            {...operandProps}
          />
        </div>
      )}
      {hasField && (
        <div style={{ width: 200 }}>
          <DynamicField field={{ ...fieldProps, disabled: disabled }} />
        </div>
      )}
    </div>
  );
}

FormFieldCondition.propTypes = {
  id: PropTypes.string.isRequired,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      operands: PropTypes.array,
      options: PropTypes.array,
      dateParts: PropTypes.array,
      type: PropTypes.object,
    })
  ).isRequired,
  formField: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  operand: PropTypes.string,
  datePart: PropTypes.string,
};

FormFieldCondition.defaultProps = {
  formField: null,
  value: null,
  disabled: false,
  operand: "",
  datePart: null,
};

export default FormFieldCondition;
